import { breakpoint } from './variables';

export function debounce(func, delay) {
    let timer;
    return () => {
        clearTimeout(timer);
        timer = setTimeout(func, delay);
    };
}

export function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function () {
                if (Date.now() - lastRan >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}

export function get_max_value(array) {
    let max = array[0];

    for (let i = 1; i < array.length; ++i) {
        if (array[i] >= max) {
            max = array[i];
        }
    }

    return max;
}

export function getSiblings(e) {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;

    // collecting siblings
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
}

export function getOffset(element) {
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset,
    };
}

export function getAdminBarHeight() {
    const adminBar = document.getElementById('wpadminbar');

    return !adminBar ? 0 : adminBar.offsetHeight;
}

export function getHeaderHeight() {
    const header = document.querySelector('.header');
    return !header ? 0 : header.offsetHeight;
}

export function formatFileSize(sizeInBytes) {
    /**
     * Convertit la taille d'un fichier en une chaîne lisible avec l'unité appropriée (Ko, Mo, Go).
     * @param {number} sizeInBytes - La taille du fichier en octets.
     * @returns {string} - La taille du fichier avec l'unité appropriée.
     */

    const units = ['octets', 'Ko', 'Mo', 'Go'];
    let size = sizeInBytes;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
}

export function isElementPartiallyVisible(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

    return vertInView && horInView;
}

export function slideUp(element, duration = 400, callback) {
    const height = element.offsetHeight;

    element.style.overflow = 'hidden';
    element.style.height = `${height}px`;
    element.style.opacity = '1';

    const startTime = performance.now();

    function animate(time) {
        const elapsedTime = time - startTime;
        const progress = Math.min(elapsedTime / duration, 1);

        element.style.height = `${height * (1 - progress)}px`;
        element.style.opacity = `${1 - progress}`;

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('opacity');
            if (callback && typeof callback === 'function') callback();
        }
    }

    requestAnimationFrame(animate);
}

export function slideDown(element, duration = 400, callback) {
    element.style.display = element.display || 'block';
    const height = element.scrollHeight;
    element.style.height = '0px';
    setTimeout(() => {
        element.style.transition = `height ${duration}ms`;
        element.style.height = `${height}px`;
        setTimeout(() => {
            element.style.height = '';
            if (callback) callback();
        }, duration);
    }, 0);
}

export function isHoverSupported() {
    const mediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    return mediaQuery.matches;
}

export const viewportWidth = {
    isDesktopNav: () => window.innerWidth >= breakpoint.laptop,
    isMobileNav: () => window.innerWidth < breakpoint.laptop,
    isTabletDown: () => window.innerWidth < breakpoint.tablet,
};
